import * as React from 'react'

import { Box, HeaderText, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  description?: string
}

const Title = ({ description }: Props) => {
  return (
    <Box gap="s8">
      <HeaderText text={i18n.t('documents.modal.esignature.title')} />
      {description && (
        <Text size="300" color="grey800">
          {description}
        </Text>
      )}
    </Box>
  )
}

export default Title
